document.addEventListener('DOMContentLoaded', function() {
  function fixWishlistButtons() {
    document.querySelectorAll('.th_wl_col_btn').forEach(function(btn) {
      if (btn.dataset.wishlistFixed) return;
      btn.dataset.wishlistFixed = 'true';
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
      }, false);
    });
  }
  fixWishlistButtons();
  new MutationObserver(fixWishlistButtons).observe(document.body, { childList: true, subtree: true });
});
